import layout from '../layout'
export default function makeNotificationRoutes({
  contentType,
  components: { NotificationListingContainer }
}) {

  return [
    {
      path: '/',
      component: layout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: `/${contentType.name}/list/`,
          component: NotificationListingContainer,
          props: {
            contentType,
          }
        },
      ]
    },
  ];
}
